import { FC } from "react";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ScatterChart,
  Scatter,
} from "recharts";
import {
  formatXAxis,
  formatYAxis,
  IAiChart,
  IScatterChartConfig,
} from "./chartConfig";
import { customTokens } from "../../theme/theme";

const AiScatterChart: FC<IAiChart> = ({ config, chartData }) => {
  const { data, title } = config as IScatterChartConfig;

  const xKey = data.x.field;
  const xLabel = data.x.label;

  const yKey = data.y.field;
  const yLabel = data.y.label;

  return (
    <ResponsiveContainer width="100%" height={400}>
      <ScatterChart margin={{ left: 40 }}>
        <CartesianGrid
          stroke={customTokens.colorNeutralBackground4}
          horizontal={true}
          vertical={false}
        />

        <XAxis
          tickFormatter={(v) =>
            typeof v === "number" ? formatYAxis(v) : formatXAxis(v)
          }
          dataKey={xKey}
          axisLine={false}
          tickLine={false}
          interval={0}
          label={{
            value: xLabel,
            position: "bottom",
            style: {
              textAnchor: "middle",
              fontWeight: 700,
              fill: customTokens.fontDarkGrayBody,
            },
          }}
        />

        <YAxis
          tickFormatter={(v) => formatYAxis(v)}
          dataKey={yKey}
          axisLine={false}
          tickLine={false}
          label={{
            value: yLabel,
            angle: -90,
            position: "insideLeft",
            offset: -20,
            style: {
              textAnchor: "middle",
              fontWeight: 700,
              fill: customTokens.fontDarkGrayBody,
            },
          }}
        />

        <Tooltip
          cursor={{ strokeDasharray: "3 3" }}
          formatter={(v) => formatYAxis(v)}
        />

        <Legend wrapperStyle={{ paddingTop: 30 }} />

        <Scatter
          name={title}
          data={chartData}
          fill={customTokens.UNFCCCBrandGraphLevel1}
        />
      </ScatterChart>
    </ResponsiveContainer>
  );
};

export default AiScatterChart;
